export default {
  "content": "<path d=\"M22 0a22 22 0 100 44 22 22 0 000-44zm6.508 21.688l-5.5 3.667c-.298.2-.649.309-1.008.312a2.11 2.11 0 01-.477 0 1.834 1.834 0 01-1.155-.954l-5.5-11a1.833 1.833 0 013.264-1.65l4.583 9.167 3.777-2.512a1.833 1.833 0 012.016 3.044v-.074z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "44",
    "height": "44",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};